<template>
  <div class="page news" v-if="post">
   <div class="container">
     <div class="row">
       <div class="col-12 mt-5">
         <img class="image-round z-depth-4" :src="post._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url" alt="">
         <h1 class="text-center">{{ post.title.rendered }}</h1>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-md-6">
              <div class="entry-content" v-html="post.content.rendered"></div>
            </div>
          </div>
        </div>
       </div>
     </div>
   </div>
  </div>
</template>
<script>
import api from '@/api'
export default {
  data () {
    return {
      post: null,
      load: true
    }
  },
  watch: {
    '$route' (to) {
      // react to route changes...
      console.log('to', to)
      this.fetchPost(to.params.slug)
    }
  },
  methods: {
    /**
     * Fetch post data
     * @param slug | WordPress blog post slug
     */
    fetchPost (slug) {
      let url = api.post + slug
      this.axios(url).then(response => {
        this.post = response.data[0]
        this.load = false
        if (this.post === undefined) {
          this.$router.push({path: '/error/404'})
          document.head.querySelector('meta[name=prerender-status-code]').content = '404'
        }
        // Ad meta propert for social sharing
        var meta = document.createElement('meta')
        meta.name = 'property'
        meta.setAttribute('content', this.post._embedded['wp:featuredmedia'][0].source_url)
        document.getElementsByTagName('head')[0].appendChild(meta)
      }).catch(error => {
        console.log(error)
        this.$router.push({path: '/error/404'})
        document.head.querySelector('meta[name=prerender-status-code]').content = '404'
      })
    }
  },
  mounted () {
    this.fetchPost(this.$route.params.slug)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Post.vue